import type { DateFormat } from '@/scopes/common/domain/types'
import { isValidDate, parseDay, toUTCDay } from '@/scopes/common/domain/utils/dates'

export const VOUCHER_EMAIL_PATTERN = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/

export function isValidVoucherBirthdate(value: string, dateFormat: DateFormat, today: Date = new Date()) {
  const birthdate = parseDay(value.trim(), dateFormat)

  return isValidDate(birthdate) && birthdate <= toUTCDay(today)
}

export function toApiVoucherBirthdate(value: string, dateFormat: DateFormat) {
  const birthdate = parseDay(value.trim(), dateFormat)
  if (!isValidDate(birthdate))
    return null
  const year = birthdate.getUTCFullYear()
  const month = String(birthdate.getUTCMonth() + 1).padStart(2, '0')
  const day = String(birthdate.getUTCDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
